<template>
  <div >
    
			<hr>
			<el-input
				type="textarea"
				:rows="4"
				placeholder="Escribe un mensaje..."
				v-model="message"
				class="mb-2"
				>
			</el-input>
			<el-button 
				type="primary"
				:loading="sending_message"
				@click="do_sent_message"
				class="float-right"
			>
				Enviar
			</el-button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
	data(){
		return {
			message: ''
		}
	},
	computed: {
		...mapState({
			sending_message: (state) => state.Chat.sending_message,
			actual_chat    : (state) => state.Chat.actual_chat,
			user           : (state) => state.Chat.user,
		})
	},
	methods: {
		...mapActions({
			send_message: 'Chat/send_message'
		}),

		do_sent_message(){
			this.send_message({
				chat: this.actual_chat.chat,
				message: {
					message: this.message,
					sender: false,
					name: this.user.name
				}
			})
			this.message = ''
		}
	}
};
</script>

<style>
</style>